module.exports = __webpack_public_path__ + "img/lg_ring_g_e_1_null@2x.8d5e03c0.png";